module.exports = __webpack_public_path__ + "static/media/ntuc.1b75bb85.png";